import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Container,
  Badge,
} from 'reactstrap';
import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';

const NavButton = (props) => {
  const { text } = props;

  return (
    <NavItem>
      <button className={'btn btn-link'}>
        <div style={{ color: 'whitesmoke' }}>{text}</div>
      </button>
    </NavItem>
  );
};

export default withNamespaces()(AppBar);
function AppBar (props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const apiCtx = React.useContext(ApiContext);
  const { t } = props;

  return (
    <div style={{ background: 'linear-gradient( #335C6F, #1E3643)' }}>
      <Container>
        <Navbar expand={'md'} dark>
          <NavbarBrand href={'#'}>
            <div style={{ color: 'whitesmoke', fontWeight: 'bold' }}>
              {apiCtx.storeName}
              <Badge color={apiCtx.isNoBinding === 'y' ? "danger" : "success"}>
                  {apiCtx.isNoBinding === 'y' ? t('AppBar.NoNeedBinding') : t('AppBar.NeedsBinding')}
              </Badge>
            </div>
          </NavbarBrand>

          <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

          <Collapse isOpen={isOpen} navbar>
            <Nav className={'ml-auto'} navbar>
              <NavButton text={t('AppBar.RealPeople')} />
              <NavButton text={t('AppBar.VideoGame')} />
              <NavButton text={t('AppBar.Sport')} />
              <NavButton text={t('AppBar.Fishing')} />
              <NavButton text={t('AppBar.Lottery')} />
              <NavButton text={t('AppBar.chessAndCards')} />
              <NavButton text={t('AppBar.Discount')} />
              <NavButton text={t('AppBar.PointsMall')} />
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    </div>
  );
};
